/*eslint-disable */
<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:body>
            <p v-if="!propOpenedInModal">{{ cvCardSubHeader }}</p>
            <form action="#">
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <label for="validationemail_body"> {{cvDomainName}}</label><br>
                  <input
                    v-model="vmAdminEmailTempFormData.app_email_domain"
                    type="text"
                    class="form-control"
                    placeholder="E.g: web.gide.ai"
                    required
                  />
                  <span class="information-color"><small>Ex: web.clatperfect.com, web.gide.ai</small></span>
                </div>
               <div class="col-md-12 mb-3">
                  <label for="validationemail_body">{{cvEmailTemplateIdLabel}}</label><br>
                  <input
                    v-model="vmAdminEmailTempFormData.email_template_id"
                    type="text"
                    class="form-control"
                    required
                  />
                  <small class="information-color">Ex: &nbsp;EMAIL_USER_REGISTRATION_ALERT</small>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationemail_body"> {{cvEmailTemplateNameLabel}}</label><br>
                    <input
                      v-model="vmAdminEmailTempFormData.email_template_name"
                      type="text"
                      class="form-control"
                      required
                    />
                    <small class="information-color">Ex: &nbsp;EMAIL_USER_REGISTRATION_ALERT</small>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationmodule_name">{{cvModuleNameLabel}}</label><br>
                  <input
                    v-model="vmAdminEmailTempFormData.module_name"
                    type="text"
                    class="form-control"
                    required
                  />
                  <small class="information-color">Ex: &nbsp;EVENT, TESTSERIES, GPATH, etc</small>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationmodule_object_id">{{cvModuleObjectIdLabel}}</label>
                  <input
                    v-model="vmAdminEmailTempFormData.module_object_id"
                    type="text"
                    class="form-control"
                    required
                  />
                  <small class="information-color">Ex: &nbsp;eve1234abcd, app123456, gpathxxx7777, etc</small>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationaction">{{cvAIActions}}</label>
                  <input
                    v-model="vmAdminEmailTempFormData.action"
                    type="text"
                    class="form-control"
                    required
                  />
                  <small class="information-color">Ex:Steps to take GPath Assessment, Reset GPath Assessment, Request for GPath Questions, How to take GPath, etc</small>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationemail_subject">{{cvEmailSubjectLabel}}</label><br>
                  <input
                    v-model="vmAdminEmailTempFormData.email_subject"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationemail_body">{{cvEmailBodyLabel}}</label>
                  <vue-editor v-model="vmAdminEmailTempFormData.email_body"></vue-editor>
                </div>
                <div>
                  <p style="font-weight: 500;" class="primary-color">Use the below macros in your email's body to get them replaced with their respective values</p>
                  <p>{USER_NAME}: &nbsp;Registrant's name</p>
                  <p>{USER_EMAIL}: &nbsp;Registrant's email address</p>
                  <p>{USER_MOBILE}: &nbsp;Registrant's mobile no.</p>

                  <p>{EVENT_TITLE}: &nbsp;Event's name/title</p>
                  <p>{EVENT_DESC}: &nbsp;Event's description</p>
                  <p>{EVENT_START_DATE}: &nbsp;Event's registration start date</p>
                  <p>{EVENT_END_DATE}: &nbsp;Event's registration ends date</p>
                  <p>{EVENT_WEB_LINK}: &nbsp;Event's website url, to access the event</p>

                  <p>{PAY_TID}: &nbsp;Gets replaced with payment Id of the registrant's paid amount for registration, if the event is a paid one</p>
                  <p>{PAY_INVOICE_URL}: &nbsp;Gets replaced with link to view/download the payment reciept for the payment made by the registrant</p>

                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="adminEmailTemplateAdd()"
                  >
                    {{ cvSubmitBtn }}
                  </button>
                </div>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast
      v-model="showToast"
      name="Toast"
      :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
      :variant="toastVariant"
      :title="toastTitle"
    >
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { AdminEmailTemplateApiObj } from "../../../FackApi/api/AdminEmailTemplate.js"
import ApiResponse from "../../../Utils/apiResponse"
import { socialvue } from "../../../config/pluginInit"
import userPermission from "../../../Utils/user_permission.js"
import { VueEditor } from "vue2-editor"

export default {
  name: "adminEmailTemplateAdd",
  components: {
    VueEditor
  },
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propAdminEmailTempObj: {
      type: Object,
      default: function () {
        return {
          "module_object_id": "",
          "module_name": ""
        }
      }
    },
    propAdminEmailTempDuplicateObj: {
      type: Object,
      default: function () {
        return {
          "email_template_id": "",
          "app_email_domain": "",
          "email_template_name": "",
          "module_object_id": "",
          "module_name": "",
          "email_subject": "",
          "email_body": ""
        }
      }
    }
  },
  data () {
    return {
      cvCardTitle: "Add Email Template",
      cvSubmitBtn: "Add",
      cvDomainName: "For which domain are your configuring the email template ?",
      cvAIActions: "Add action keyword for AI to understand the context",
      cvModuleObjectIdLabel: "Module Object Id",
      cvModuleNameLabel: "Associated Module Name",
      cvEmailSubjectLabel: "Email Subject",
      cvEmailTemplateNameLabel: "Email Template Name",
      cvEmailBodyLabel: "Email Body",
      cvEmailTemplateIdLabel: "Email Template Id",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      cvLoadingStatus: false,
      toastTitle: "Email Template Added",
      vmAdminEmailTempFormData: Object.assign({}, this.initFormData()),
      vmAdminEmailTempDesc: null,
      vmAdminEmailTempType: null
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  async beforeMount () {
    // Auth Access for Current User Role
    if (this.userData.user_role == "USERROLE11114") {
      // We will display only the sessions of the user, It is necessary when the user has multiple sessions and he/she wants to view the session
      // DONT CARE CASE
    }
    else if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  mounted () {
    socialvue.index()

    if (this.propAdminEmailTempObj) {
      this.vmAdminEmailTempFormData = this.propAdminEmailTempObj
    }

    if (this.propAdminEmailTempDuplicateObj && this.propAdminEmailTempDuplicateObj.email_template_id) {
      this.vmAdminEmailTempFormData = {
        ...this.propAdminEmailTempDuplicateObj,
        email_template_id: this.propAdminEmailTempDuplicateObj.email_template_id.replace(/copy$/i, "") + "-copy"
      }
    }
  },
  methods: {
    /**
     * initFormData
     */
    initFormData () {
      return {
        "email_template_id": "",
        "email_template_name": "",
        "module_object_id": "",
        "module_name": "",
        "email_subject": "",
        "email_body": ""
      }
    },
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmAdminEmailTempFormData) {
          if (!this.vmAdminEmailTempFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
      }
    },
    /**
     * adminEmailTemplateAdd
     */
    async adminEmailTemplateAdd () {
      // if (!this.validate()) {
      //   return false
      // }
      try {
        this.cvLoadingStatus = true

        if (!this.vmAdminEmailTempFormData.history) {
          this.vmAdminEmailTempFormData.history = []
        }

        const newHistoryEntry = {
          user_id: this.userData.user_id,
          modified_on: new Date().toISOString()
        }

        this.vmAdminEmailTempFormData.history = JSON.stringify(newHistoryEntry)

        let adminEmailTemplateAddResp = await AdminEmailTemplateApiObj.adminEmailTemplateAdd(this, this.vmAdminEmailTempFormData)
        await ApiResponse.responseMessageDisplay(this, adminEmailTemplateAddResp)
        if (adminEmailTemplateAddResp && !adminEmailTemplateAddResp.resp_status) {
          return false
        }
        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitCloseadminEmailTemplateAddModal", this.vmAdminEmailTempFormData)
        }
        this.vmAdminEmailTempFormData = Object.assign({}, this.initFormData())
        this.vmAdminEmailTempFormData.email_body_textarea = ""
        this.vmAdminEmailTempFormData.email_body_vueeditor = ""
      }
      catch (err) {
        console.error("Exception occurred at adminEmailTemplateAdd() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  }
}
</script>
<style>
  .textarea {
    height: 195px !important;
    overflow-y: scroll;
    line-height: 18px !important;
  }
</style>
